<script setup>

import { useHead } from "@unhead/vue";
import ImageGridOurWork from '@static/scripts/components/ImageGridOurWork/Component.vue';

useHead({
	title: "Real-World Examples of Custom Swag Creations by Swagger",
	meta: [
		{ name: "description", content: "Browse Swagger’s portfolio of custom swag projects for companies & events across industries. Get inspired by creative ideas & high-quality products." },
		{ rel: "canonical", href: "https://giveswagger.com/our-work" },
		{ property: "og:title", content: "Real-World Examples of Custom Swag Creations by Swagger" },
		{ property: "og:description", content: "Browse Swagger’s portfolio of custom swag projects for companies & events across industries. Get inspired by creative ideas & high-quality products." },
		{ property: "og:image", content: "https://giveswagger.com/assets/swagger-social.jpg" },
		{ property: "og:url", content: "https://giveswagger.com/our-work" }
	]
})

</script>

<template lang="pug">

.page
	header.page__header
		h1 Our Work
		.copy
			p.gamma At Swagger, we love creating meaningful branded experiences that bring to life your vision and goals while embracing sustainability. We thrive on collaboration, creativity, innovation, joy, and obsessing over the details. It's swag with a purpose for the company AND the planet.

	.section.section.section--ourwork
		ImageGridOurWork

</template>
